<template>
  <div>
    <org-chart
      @node-click="nodeClicked"
      :datasource="ds"
    ></org-chart>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrgChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";
export default {
  components: { OrgChart },
  data() {
    return {
      ds: {
        id: "1",
        name: "Automations",
        title: "Overview",
        children: [
          { id: "2", name: "Booking created", title: "Marcom" },
          {
            id: "3",
            name: "Birthday",
            title: "Guest profile",
            children: [
              { id: "4", name: "Upsell flow", title: "Guest profile" },
              {
                id: "5",
                name: "Newsletter flow",
                title: "Newsletter",
                children: [
                  { id: "6", name: "Todo", title: "Todo" },
                  { id: "7", name: "Todo", title: "Todo" },
                ],
              },
            ],
          },
          { id: "9", name: "Nightpay created", title: "Nightpay" },
        ],
      },
    };
  },
  methods: {
    nodeClicked(node) {
      console.log("Node clicked", node);
    },
  },
  computed: {
    ...mapGetters({
      automations: "automations/automations",
    }),
  },

  created() {},
};
</script>